var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 18.9987C11.0833 20.7476 9.66557 22.1654 7.91667 22.1654C6.16776 22.1654 4.75 20.7476 4.75 18.9987C4.75 17.2497 6.16776 15.832 7.91667 15.832C9.66557 15.832 11.0833 17.2497 11.0833 18.9987Z",
    fill: "#3E0292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 18.9987C22.1666 20.7476 20.7489 22.1654 18.9999 22.1654C17.251 22.1654 15.8333 20.7476 15.8333 18.9987C15.8333 17.2497 17.251 15.832 18.9999 15.832C20.7489 15.832 22.1666 17.2497 22.1666 18.9987Z",
    fill: "#3E0292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2501 18.9987C33.2501 20.7476 31.8324 22.1654 30.0834 22.1654C28.3345 22.1654 26.9167 20.7476 26.9167 18.9987C26.9167 17.2497 28.3345 15.832 30.0834 15.832C31.8324 15.832 33.2501 17.2497 33.2501 18.9987Z",
    fill: "#3E0292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menuDots.ad7e62d0dcaf305d505ec63f1b7cb0d7.svg";
export { ForwardRef as ReactComponent };